var React = require('react');

function Compass (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("g",{"id":"icons","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"transform":"translate(-166.000000, -505.000000)","id":"locate_me_icn","stroke":"#BB0104","strokeWidth":"0.925925926","fill":"#BB0104"},React.createElement("path",{"d":"M179.5,531 C172.596441,531 167,525.403559 167,518.5 C167,511.596441 172.596441,506 179.5,506 C186.403559,506 192,511.596441 192,518.5 C192,525.403559 186.403559,531 179.5,531 Z M171,519.438434 L178.482608,519.438434 L178.482608,527 L186,512 L171,519.438434 Z"})))]);
}

Compass.defaultProps = {"width":"27px","height":"27px","viewBox":"0 0 27 27","version":"1.1"};

module.exports = Compass;

Compass.default = Compass;
